export default {"src":"/pro/_next/static/media/pump.75e6db57.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};